const pageFooterType = 'PAGE_FOOTER';

const initialState = {
    pageFooter: true
};

export const footerActions = {
    handleSetPageFooter: () => ({ type: pageFooterType }),
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case pageFooterType:
            return { ...state, pageFooter: !state.pageFooter };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/admin/footer.js